import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Certificate } from '@app/_models/certificate';

@Component({
  selector: 'app-rsa-search-form',
  templateUrl: './rsa-search-form.component.html',
  styleUrls: ['./rsa-search-form.component.less']
})
export class RsaSearchFormComponent implements OnInit {
  @Input() loading = false;
  @Output() search = new EventEmitter<any>();
  @Output() reset = new EventEmitter<void>();

  certificateReportForm: UntypedFormGroup;
  submitted = false;

  constructor(private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.certificateReportForm = this.formBuilder.group({
      certificateNumber: [''],
      chasisNumber: [''],
      contactNumber: [''],
    });
  }

  get f() { return this.certificateReportForm.controls; }

  onSubmit() {
    this.submitted = true;
    
    // stop here if form is invalid
    if (this.certificateReportForm.invalid) {
      return;
    }

    this.search.emit(this.certificateReportForm.getRawValue());
  }

  onReset() {
    this.submitted = false;
    this.certificateReportForm.reset();
    this.reset.emit();
  }
}
